import React, { forwardRef } from 'react';

import { Input } from 'antd';
const BaseRowInput = (props) => {
  const { label, labelStyle, readonly, height, ...rest } = props;

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: height || '5.8rem',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0rem 1rem 0rem 1rem',

      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
    },
    label: {
      display: 'flex',
      // height: '2rem',
      height: '90%',
      width: '80%',
      alignItems: 'center',
      justifyContent: 'flex-start',
      // font
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '1.5rem',
      // color: 'black',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      // height: '3.8rem',
      height: '90%',
      width: '20%',
      padding: '0rem 1rem 0rem 1rem',
      background: 'transparent',
      border: '1px solid #DBDADE',
      borderRadius: 6,

      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '1.5rem',
    },
    input: {
      display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'flex-end',
      height: '72%',
      width: '20%',
      margin: 0,
      // border: 0,
      // marginTop: '-0.2rem',
    },
  };

  return (
    <div style={{ ...styles.container }}>
      <div style={{ ...styles.label, ...labelStyle }}>{label}</div>
      {readonly === true ? (
        <div style={{ ...styles.text }}>{props.value}</div>
      ) : (
        <Input style={{ ...styles.input }} {...rest} />
      )}
    </div>
  );
};

export default forwardRef(BaseRowInput);
